import {SortField} from "./table-data.model";
import {isDefined} from "../../features/utils/functions.utils";


export interface MenuItem {
  id: string;
  isRoute?: boolean;
  route?: string;
  icon: string;
  label?:string
  color?: string
}

export const DashboardMenuItems: MenuItem[] = [
  { id: 'general', color: '#6366F1', icon: 'pi pi-envelope'},
  { id: 'rescue', color: '#EC4899', icon: 'pi pi-truck'},
  { id: 'restore', color: '#10B981', icon: 'pi pi-wrench'},
  { id: 'users', color: '#3B82F6', icon: 'pi pi-users'},
  { id: 'vehicles', color: '#6B7280', icon: 'pi pi-car'},
];

export const NavigationItems = [
    'general',
    'rescue',
    'restore',
    'users',
    'vehicles',
];

export interface Messages {
    description: string;
    type: string /** FIXME: ENUM ?  */
}

export interface Sort {
    /**FIXME: */
    [k: string]: any;
    code: string;
    description: string;
}

//FIXME capire chi la usa è sbagliata -> unire a Pagination
export interface PaginationRequest {
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    first?: boolean;
    last?: boolean;
}

export interface Pagination {
    pageNumber: number;
    pageSize: number;
    totalElements: number;
    first?: boolean;
    last?: boolean;
}

export interface PageResponse<T> {
    items: T[];
    messages: Messages[];
    pagination: Pagination;
}

export interface PageRequest{
  page: number;
  pageItems?: number;
  filter?: {[key: string]: any};
  sort?: string[];
}

export interface HttpRequestParam {[param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;}

export function toHttpRequestParam(pageRequest?: PageRequest): HttpRequestParam  {
  const params: HttpRequestParam = {}
  if( isDefined(pageRequest)){
    if(isDefined(pageRequest?.page)) params["page"] = pageRequest.page;
    if(isDefined(pageRequest?.pageItems)) params["pageItems"] = pageRequest.pageItems;
    if(isDefined(pageRequest?.sort)) params["sort"] = pageRequest.sort;
    if(isDefined(pageRequest?.filter)){
      const {filter} = pageRequest;
      Object.keys(filter).forEach( key => {

        if(isDefined(filter) && isDefined(filter[key])){
          params[key] = filter[key];
        }
      })
    }
  }
  return params;
}

export interface NumberConfig {
    obsolete: boolean;
    id: string;
    pattern: string;
    nextNumber?: number;
    minNumberLength?: number;
    numberLPadCode?: string;
    resetOnYearChange: boolean;
    enableManualInsert: boolean;
    useDefaultNumber: boolean;
    example: string;
}

export interface Filter {
    [k: string]: any;
}

export interface PaginationFiltersState {
    [context: string]: PaginationFilterState; // Un estado por cada contexto
}

export interface PaginationFilterState {
    //filterObj?: {[key: string]: any} | {};
    filter?: Filter | {};
    pagination?: PaginationRequest | {};
    sort?: SortField[];
}

export interface RowSelect<T> {
    data: T;
    index: number | string | undefined;
    originalEvent: PointerEvent;
    type: 'row' | 'column';
}

export interface Company extends SharedEntity {
  code: string
  description: string;
  type: string;
  ownerId: string;
}

export interface SharedEntity {
  id?: any,
  obsolete?: boolean
  creationTime?: string
  updateTime?: string

  [k: string]: any;
}
export interface Protocol {
  date: string
  id: number
  number: string
  status: string
  time: string
  type: string
  fullNumber: string;
  dateNumber: string;
}

export interface BaseProtocol extends SharedEntity{
  date: string
  documentCount: number
  hasDocuments: boolean
  hasImages: boolean
  id: number
  imageCount: number
  obsolete: boolean
  protocol: Protocol
  time: string
}

export interface StreetType extends CodeDescriptionItem{
  needDirection: boolean
  needKm: boolean
  needStreetCode: boolean
}

export interface CodeDescriptionItem {
  id?: any
  obsolete: boolean
  code: string
  description: string
  numOrder: number
  creationTime?: string
  createdBy?: string
  notObsolete?: boolean
}

export interface Address {
  streetType: StreetType
  streetCode: string
  direction: string
  city: string
  street: string
  streetNumber: string
  streetKm: string
}

export interface Vehicle extends SharedEntity{
  obsolete?: boolean
  brand: string
  model: string
  number: string
  type: CodeDescriptionItem
}


export interface Driver extends SharedEntity{
  fullName: string
  email: string
  representCompany: boolean;
}

export interface CompanyVehicle extends SharedEntity{
  brand?: string
  model?: string
  number?: string
  description?: string
}

export const PaymentType= {
  RECEIPT: 'RECEIPT',
  INVOICE: 'INVOICE'
}
export type PaymentTypeValues = 'INVOICE' | 'RECEIPT';

export const IOType= {
  IN: 'IN',
  OUT: 'OUT'
}
export type IOTypeValues = 'INVOICE' | 'RECEIPT';

export interface InvoiceData extends SharedEntity {
  legalName: string;
  address: string;
  fiscalCode: string;
  uniqueCode: string;
  contact: string;
}

export interface Document {
    obsolete: boolean
    id: string
    name: string
    bytes: number
    contentType: string
    type: string
    dateTime: Date | string

}

export const CONTEXTS = {
    GENERAL: 'general',
    RESCUE: 'rescue',
    RESTORE: 'restore',
    VEHICLES: 'vehicle-list',
    DRIVERS: 'driver',
    USERS: 'users',
    NOTE: 'note',
}




export interface Note {
    author: Author
    creationTime: string
    edited: boolean
    id: number
    note: string;
    obsolete: boolean
    updateTime: string
}

export interface Author {
    companyId: number
    confirmed: boolean
    creationTime: string
    email: string
    fullName: string
    id: number
    obsolete: boolean
    updateTime: string
}


//FIXME DA TRADURRE CON CLASSE DI UTILITà
export const ProtocolStatusValues = ['PROCESSING', 'CLOSED','CANCELED'];


export interface SelectOption{
  value: any;
  description: string;
  selected?: boolean;
}

export const pEditorDefaultToolbarOptions =  [
  [{ header: [1, 2, 3, false] }],
  ['bold', 'italic', 'underline'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: [] }],
  [{ indent: '-1' }, { indent: '+1' }],
  //['blockquote', 'code-block'],
  ['clean']                               // remove formatting button
];

export interface ModalChangeEvent{
  reload: boolean,
  visible: boolean
}

export interface StatusChange<T> {
  status: T;
  note?:string;
}

